import { Component, output } from '@angular/core';
import { RidButton } from '../rid-button/rid-button';

@Component({
  selector: 'rid-correct-answer-modal',
  imports: [RidButton],
  templateUrl: './rid-correct-answer-modal.html',
  host: {
    class: 'absolute',
    'animate.enter': 'anim-pop-in',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidCorrectAnswerModal {
  continue = output<void>();
}
